import script from "./FilePermitionsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePermitionsTab.vue?vue&type=script&setup=true&lang=ts"

import "./FilePermitionsTab.vue?vue&type=style&index=0&id=3907bbeb&scoped=true&lang=scss"
import "./FilePermitionsTab.vue?vue&type=style&index=1&id=3907bbeb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3907bbeb"]])

export default __exports__